export function getTemplate(templateName) {
    return document.querySelector('#' + templateName + '-template').innerHTML;
}

export function checkSearchShouldStart(helper) {
    // If the query is empty, it is not the search page, and there are no hierarchicalCategories set, stop the search from running
    if( helper.state.query === '' && window.wpData.pageName['value'] !== 'search_page' ) {
        return false;
    } else {
        return true;
    }
}

export function getQueryParameterValue(param) {
    const url_string = window.location.href,
        url = new URL(url_string);

    return url.searchParams.get(param)
}

export function prettify(str) {
    return str.replace(/(-|^)([^-]?)/g, function(_, prep, letter) {
        return (prep && ' ') + letter.toUpperCase();
    });
}

export function setDateFormat(timestamp) {
    let tempDate = new Date(timestamp * 1000);
    return tempDate.getFullDate() + '/' + tempDate.getFullMonth() + '/' + tempDate.getFullYear();
}

Date.prototype.getFullDate = function() {
    return ('0' + this.getDate()).slice(-2);
};

Date.prototype.getFullMonth = function() {
    return ('0' + (this.getMonth() + 1)).slice(-2);
};

export function toTimestamp(date) {
    date -= date % (24 * 60 * 60 * 1000);
    date += new Date().getTimezoneOffset() * 60 * 1000;
    date = date / 1000;

    return date;
}

export function createIsbnsParameter(isbnsArray) {
    return isbnsArray.split(',').map(product => "objectID:" + product).join(" OR ");
}

export const client = supafolio("CHR8V2GO8G", "1a9084f44dd9c1657a34773ffd9b9227", "macmillan-au");